
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route){
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName, 
		fieldValue: route.params.fieldValue
	}
}


let routes = [
	//Dashboard routes


//efos routes
			{
				path: '/efos/:fieldName?/:fieldValue?',
				name: 'efoslist',
				component: () => import('./pages/efos/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/efos/view/:id', 
				name: 'efosview', 
				component: () => import('./pages/efos/view.vue'), 
				props: true
			},
		
			{ 
				path: '/efos/add', 
				name: 'efosadd', 
				component: () => import('./pages/efos/add.vue'), 
				props: true
			},
	
			{ 
				path: '/efos/edit/:id', 
				name: 'efosedit', 
				component: () => import('./pages/efos/edit.vue'), 
				props: true
			},
		


//invoices routes
			{
				path: '/invoices/:fieldName?/:fieldValue?',
				name: 'invoiceslist',
				component: () => import('./pages/invoices/list.vue'), 
				props: route => passRouteToProps(route)
			},

			{ 
				path: '/invoices/view/:id', 
				name: 'invoicesview', 
				component: () => import('./pages/invoices/view.vue'), 
				props: true
			},

			{ 
				path: '/invoices/add', 
				name: 'invoicesadd', 
				component: () => import('./pages/invoices/add.vue'), 
				props: true
			},

			{ 
				path: '/invoices/edit/:id', 
				name: 'invoicesedit', 
				component: () => import('./pages/invoices/edit.vue'), 
				props: true
			},
		

//permissions routes
			{
				path: '/permissions/:fieldName?/:fieldValue?',
				name: 'permissionslist',
				component: () => import('./pages/permissions/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/permissions/view/:id', 
				name: 'permissionsview', 
				component: () => import('./pages/permissions/view.vue'), 
				props: true
			},
		
			{ 
				path: '/permissions/add', 
				name: 'permissionsadd', 
				component: () => import('./pages/permissions/add.vue'), 
				props: true
			},
	
			{ 
				path: '/permissions/edit/:id', 
				name: 'permissionsedit', 
				component: () => import('./pages/permissions/edit.vue'), 
				props: true
			},
		

//repse routes
			{
				path: '/repse/:fieldName?/:fieldValue?',
				name: 'repselist',
				component: () => import('./pages/repse/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/repse/view/:id', 
				name: 'repseview', 
				component: () => import('./pages/repse/view.vue'), 
				props: true
			},
		
			{ 
				path: '/repse/add', 
				name: 'repseadd', 
				component: () => import('./pages/repse/add.vue'), 
				props: true
			},
	
			{ 
				path: '/repse/edit/:id', 
				name: 'repseedit', 
				component: () => import('./pages/repse/edit.vue'), 
				props: true
			},
		

//roles routes
			{
				path: '/roles/:fieldName?/:fieldValue?',
				name: 'roleslist',
				component: () => import('./pages/roles/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/roles/view/:id', 
				name: 'rolesview', 
				component: () => import('./pages/roles/view.vue'), 
				props: true
			},
		
			{ 
				path: '/roles/add', 
				name: 'rolesadd', 
				component: () => import('./pages/roles/add.vue'), 
				props: true
			},
	
			{ 
				path: '/roles/edit/:id', 
				name: 'rolesedit', 
				component: () => import('./pages/roles/edit.vue'), 
				props: true
			},
		

//suppliers routes
			{
				path: '/suppliers/:fieldName?/:fieldValue?',
				name: 'supplierslist',
				component: () => import('./pages/suppliers/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/suppliers/view/:id', 
				name: 'suppliersview', 
				component: () => import('./pages/suppliers/view.vue'), 
				props: true
			},
		
			{ 
				path: '/suppliers/add', 
				name: 'suppliersadd', 
				component: () => import('./pages/suppliers/add.vue'), 
				props: true
			},
	
			{ 
				path: '/suppliers/edit/:id', 
				name: 'suppliersedit', 
				component: () => import('./pages/suppliers/edit.vue'), 
				props: true
			},
		

//users routes
			{
				path: '/users/:fieldName?/:fieldValue?',
				name: 'userslist',
				component: () => import('./pages/users/list.vue'), 
				props: route => passRouteToProps(route)
			},
	
			{ 
				path: '/users/view/:id', 
				name: 'usersview', 
				component: () => import('./pages/users/view.vue'), 
				props: true
			},
		
			{ 
				path: '/account/edit', 
				name: 'usersaccountedit', 
				component: () => import('./pages/account/accountedit.vue'), 
				props: true
			},
	
			{ 
				path: '/account', 
				name: 'usersaccountview', 
				component: () => import('./pages/account/accountview.vue'), 
				props: true
			},
	
			{ 
				path: '/users/add', 
				name: 'usersadd', 
				component: () => import('./pages/users/add.vue'), 
				props: true
			},
	
			{ 
				path: '/users/edit/:id', 
				name: 'usersedit', 
				component: () => import('./pages/users/edit.vue'), 
				props: true
			},
		

	
	
//Password reset routes
			{ 
				path: '/index/forgotpassword', 
				name: 'forgotpassword', 
				component: () => import('./pages/index/forgotpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword', 
				name: 'resetpassword', 
				component: () => import('./pages/index/resetpassword.vue'), 
				props: true
			},
			{ 
				path: '/index/resetpassword_completed', 
				name: 'resetpassword_completed', 
				component: () => import('./pages/index/resetpassword_completed.vue'), 
				props: true
			},
	
	
	
	{ 
		path:  '/error/forbidden', 
		name: 'forbidden', 
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{ 
		path: '/error/notfound', 
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)', 
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {
	
const auth = useAuth();

	
	const user = auth.user;
	if(user){
		routes.push({ path: '/', alias: '/invoices', name: 'invoices', component: () => import(`./pages/invoices/list.vue`) });
	}
	else{
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion){
			if(savedPostion) return savedPostion;
			return { top:0 }
		}
	});
	
	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if(!user){
				return next({ path: '/',  query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({path: "/error/forbidden"});
			}
		}

		if(user && to.name == "index"){
			//already logged in, show home when try to access index page
			return next({ path: "/home"});
		}

		//navigate to redirect url if available
		if(to.name == "home" && to.query.nexturl){
			return next({ path: to.query.nexturl});
		}

 		//close dialog from previous page
		//store.closeDialogs('app/closeDialogs');
		
		next();
	});

	return router;
}
